import { Box, Button, Paper, styled, Typography } from '@mui/material'
import scStyled from 'styled-components'

export const Paragraph = styled(Typography)`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.3;
  color: #4e5256;
  text-transform: 'lowercase';
`

interface ISignOutButtonProps {
  customercolor?: string
}

export const SignOutButton = styled(Button)<ISignOutButtonProps>`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.3;
  color: ${({ customercolor }) => customercolor};

  padding: 0;
`

export const UserCard = styled(Paper)`
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
`

export const User = styled(Typography)`
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.2;
  color: #202126;
`

export const Email = styled(Typography)`
  font-weight: 400;
  font-size: 0.6875rem;
  line-height: 1.2;
  color: #5f6267;
`

export const ImageContainer = styled(Box)`
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
`

export const Image = scStyled.img`
  height: 100%;
  width: 100%;
  border-radius: inherit;
`
